var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgListingicon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5816 2.58531C12.2067 2.21034 11.6983 1.99962 11.1681 1.99951H3.9986C3.46835 1.99951 2.95982 2.21015 2.58488 2.58509C2.20994 2.96003 1.9993 3.46856 1.9993 3.99881V11.1683C1.99941 11.6985 2.21013 12.207 2.58509 12.5818L11.286 21.2828C11.7404 21.7342 12.3549 21.9876 12.9954 21.9876C13.636 21.9876 14.2505 21.7342 14.7048 21.2828L21.2825 14.7051C21.734 14.2507 21.9874 13.6362 21.9874 12.9957C21.9874 12.3551 21.734 11.7406 21.2825 11.2863L12.5816 2.58531Z",
    stroke: "#0A0A0A",
    strokeWidth: 1.9993,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49756 7.99756C7.7737 7.99756 7.99756 7.7737 7.99756 7.49756C7.99756 7.22142 7.7737 6.99756 7.49756 6.99756C7.22142 6.99756 6.99756 7.22142 6.99756 7.49756C6.99756 7.7737 7.22142 7.99756 7.49756 7.99756Z",
    fill: "#0A0A0A",
    stroke: "#0A0A0A",
    strokeWidth: 1.9993,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListingicon);
export default __webpack_public_path__ + "static/media/listingicon.cf9d609e041402eb370bce0afff0bc1e.svg";
export { ForwardRef as ReactComponent };